<div class="content-page">
  <ng-container *ngIf="stepIndex < 4 && !showResult">
    <p class="text-blue fw-bold fs-5 text-start mb-4  mt-5 mt-lg-0">Responde las siguientes preguntas:</p>
  </ng-container>
  <form [formGroup]="formManagement">
    <ng-container *ngIf="stepIndex === 1">
    <div class="d-flex flex-column flex-lg-row gap-lg-5 gap-0 mb-lg-5 mb-0">
      <div class="w-100">
        <div class="text-start">
          <span class="text-blue fs-6 fw-light question">Nombres y apellidos</span>
        </div>
        <mat-form-field class="w-100 form-calculate">
          <input matInput formControlName="name">
          <mat-error *ngIf="formManagement.get('name')?.hasError('required')">Este campo es obligatorio</mat-error>
        </mat-form-field>
      </div>
      <div class="w-100">
        <div class="text-start">
          <span class="text-blue fs-6 fw-light question">Edad</span>
        </div>
        <mat-form-field class="w-100 form-calculate">
          <input matInput formControlName="age" appOnlyNumber>
          <mat-error *ngIf="formManagement.get('age')?.hasError('required')">Este campo es obligatorio</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="d-flex flex-column flex-lg-row gap-lg-5 gap-0">
      <div class="w-100">
        <div class="text-start">
          <span class="text-blue fs-6 fw-light question">Correo electrónico</span>
        </div>
        <mat-form-field class="w-100 form-calculate">
          <input matInput formControlName="email">
          <mat-error *ngIf="formManagement.get('email')?.hasError('required')">Este campo es obligatorio</mat-error>
          <mat-error *ngIf="formManagement.get('email')?.hasError('email')">El formato del correo electrónico es incorrecto</mat-error>
        </mat-form-field>
      </div>
      <div class="w-100">
        <div class="text-start">
          <span class="text-blue fs-6 fw-light question">País de residencia</span>
        </div>
        <mat-form-field class="w-100 form-calculate">
          <input matInput formControlName="country">
          <mat-error *ngIf="formManagement.get('country')?.hasError('required')">Este campo es obligatorio</mat-error>
        </mat-form-field>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="stepIndex === 2">
    <div class="d-flex flex-column flex-lg-row gap-lg-5 gap-0 mb-lg-5 mb-0">
      <div class="w-100  mb-3 mb-lg-0">
        <div class="text-start">
          <span class="text-blue fs-6 fw-light question">¿Cuál es su conocimiento del mercado de capitales?</span>
        </div>
        <div class="d-flex flex-column align-items-start">
          <mat-radio-group formControlName="capitalKnowledge">
            <mat-radio-button class="question" *ngFor="let item of knowledgeMarketItems" [value]="item.label">{{item.label}}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="w-100  mb-3 mb-lg-0">
        <div class="text-start">
          <span class="text-blue fs-6 fw-light question">¿Cuál es su objetivo de inversión?</span>
        </div>
        <div class="d-flex flex-column align-items-start">
          <mat-radio-group formControlName="objectiveInvestment">
            <mat-radio-button class="question" *ngFor="let item of objectiveInvestmentItems" [value]="item.label">{{item.label}}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column flex-lg-row gap-lg-5 gap-0 align-items-end">
      <div class="w-100  mb-3 mb-lg-0">
        <div class="text-start">
          <span class="text-blue fs-6 fw-light question">¿Hace cuánto realiza inversiones financieras?</span>
        </div>
        <div class="d-flex flex-column align-items-start">
          <mat-radio-group formControlName="investmentFinancial">
            <mat-radio-button class="question" *ngFor="let item of investmentFinancialItems" [value]="item.label">{{item.label}}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="w-100">
        <div class="text-start">
          <span class="text-blue fs-6 fw-light question">¿Cuándo piensa retirar sus inversiones?</span>
        </div>
        <div class="d-flex flex-column align-items-start">
          <mat-radio-group formControlName="retirementDate">
            <mat-radio-button class="question" *ngFor="let item of retirementDateItems" [value]="item.label">{{item.label}}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="stepIndex === 3">
    <div class="d-flex flex-column flex-lg-row gap-lg-5 gap-0 mb-lg-5 mb-0">
      <div class="w-100  mb-3 mb-lg-0">
        <div class="text-start">
          <span class="text-blue fs-6 fw-light question">Si sus inversiones perdieran un 25% en los últimos meses, ¿qué haría?</span>
        </div>
        <div class="d-flex flex-column align-items-start">
          <mat-radio-group formControlName="retirementAction">
            <mat-radio-button class="question" *ngFor="let item of retirementActionItems" [value]="item.label">{{item.label}}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="w-100  mb-3 mb-lg-0">
        <div class="text-start">
          <span class="text-blue fs-6 fw-light question">¿Cuánto capital estima invertir?</span>
        </div>
        <mat-form-field class="w-100 form-calculate">
          <input matInput formControlName="amountInvestment" appOnlyNumber  currencyMask [options]="{ thousands: ',', precision: 0, align: 'left' }">
          <mat-error *ngIf="formManagement.get('amountInvestment')?.hasError('required')">Este campo es obligatorio</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="d-flex flex-column flex-lg-row gap-lg-5 gap-0 align-items-start">
      <div class="w-100 mb-3 mb-lg-0">
        <div class="text-start">
          <span class="text-blue fs-6 fw-light question">¿Qué nivel de retorno y variación de precios está dispuesto a aceptar?</span>
        </div>
        <div class="d-flex flex-column align-items-start">
          <mat-radio-group class="d-flex flex-column" formControlName="returnVariation">
            <mat-radio-button class="question" *ngFor="let item of returnVariationItems" [value]="item.label">{{item.label}}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="w-100">
        <div class="text-start">
          <span class="text-blue fs-6 fw-light question">¿Qué porcentaje de sus ahorros totales representaría esa inversión?</span>
        </div>
        <div class="d-flex flex-column align-items-start">
          <mat-radio-group formControlName="percentageSavings">
            <mat-radio-button *ngFor="let item of percentageSavingsItems" [value]="item.label">{{item.label}}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="stepIndex === 4 && showResult">
    <div class="text-start">
        <h1 class="text-blue fw-semibold fs-4 mb-3 text-coberture pt-5 pt-xxl-0">Hola {{formManagement.get('name')?.value}} !</h1>
        <div class="d-flex flex-column flex-lg-row gap-3 h-100">
          <div class="text-start w-100 d-flex flex-column gap-3 content-left">
            <div class="bg-white shadow-sm rounded px-3 pt-3 d-flex flex-column content-calculate">
              <div class="d-flex flex-column gap-4 content-coberture rounded w-100 p-3 text-center justify-content-center">
                <p class="text-blue m-0 fs-6 text-coberture">{{result?.description}}</p>
                <h1 class="fw-bold text-blue amount m-0">{{result?.label}}</h1>
              </div>
              <div class="d-flex align-items-center justify-content-center px-3 py-4 py-lg-5">
                <div class="w-100 text-center">
                  <img src="assets/svg/icon-money-2.svg" alt="icon.svg" width="32">
                </div>
                <div class="w-100 text-center icon-center">
                  <img src="assets/svg/icon-people.svg" alt="icon.svg" width="32">
                </div>
                <div class="w-100 text-center">
                  <img src="assets/svg/icon-teacher.svg" alt="icon.svg" width="32">
                </div>
              </div>
            </div>
            <div class="content-description-step-3 bg-white shadow-sm rounded p-3 h-100">
              <p class="text-blue fw-semibold mt-4 text-categorie">Categorias</p>
              <p class="text-blue fw-light text-categorie">
              Este monto seria dividido según lo que pudimos analizar en las siguientes categorías: 
              Vivienda, alimentación, educación, servicios varios, ahorro y protección, recreación 
              y viajes y otros.</p>
            </div>
          </div>
          <div class="content-center bg-white p-4 rounded shadow-sm w-100">
            <p class="fw-bold text-blue text-categorie">Distribución de monto estimado en categorías:</p>
            <div class="d-flex align-items-center flex-column flex-md-row flex-lg-column flex-xxl-row justify-content-center content-pie py-5">
              <div>
                <canvas baseChart
                  [data]="chartData"
                  [options]="chartOptions"
                  [type]="chartType"
                  class="pie-chart">
                </canvas>
                </div>
                <div class="d-flex align-items-start flex-column gap-3 content-legend">
                  <ng-container *ngFor="let item of chartData.labels; let i = index">
                    <div class="d-flex gap-3">
                      <div class="box-label" [style.background-color]="backgroundColors[i]"></div>
                      <span class="fs-6 text-blue fw-light">{{item}}</span>
                    </div>
                  </ng-container>
              </div>
            </div>
          </div>
          <div class="bg-white p-3 d-flex flex-column gap-2 gap-lg-5 rounded shadow-sm content-right py-4 py-lg-5 justify-content-around">
            <img src="assets/images/kaizen-logo.webp" alt="logo" width="150" class="mx-auto mx-lg-0 mb-3 mb-lg-0">
            <div class="text-start">
              <p class="fw-semibold fs-7 text-blue mb-1 mb-lg-3">Importante:</p>
              <p class="fw-light fs-7 text-blue mb-2 mb-lg-3">Esta distribución fue elaborada a partir de los datos que nos proporcionaste y algunos supuestos genéricos.</p>
              <p class="fw-light fs-7 text-blue">Para una asesoría personalizada contáctate con un Asesor(a) Kaizen.</p>
            </div>
            <div class="d-flex flex-column flex-md-row flex-lg-column gap-2 align-items-center w-100 justify-content-center">
              <div class="btn-continue d-flex align-items-center justify-content-center pointer gap-3 rounded" (click)="saveForm(true)">
                <span class="text-white fs-6 text-solution-button">Contactar</span>
                <img src="assets/svg/icon-arrow-right-linear.svg" alt="logo" width="24">
              </div>
              <div class="btn-cancel d-flex align-items-center justify-content-center pointer gap-3 rounded mb-2 mb-lg-0" (click)="resetForm()">
                <span class="text-blue fs-6 text-solution-button">Volver a calcular</span>
              </div>
            </div>
          </div>
        </div>
      </div>
  </ng-container>
  <ng-container *ngIf="stepIndex !== 4">
    <div class="d-flex flex-column-reverse flex-lg-row align-items-center gap-3 justify-content-end mt-5">
      <span class="btn-back pointer" (click)="backStep()">Volver</span>
      <div class="btn-continue d-flex align-items-center justify-content-center pointer gap-3" (click)="nextStep()" [class.disabled]="validateteStep()">
        <span class="text-white fs-5">{{stepIndex !== 3 ? 'Siguiente' : 'Calcular'}}</span>
        <img src="assets/svg/icon-arrow-right-linear.svg" alt="logo" width="24">
      </div>
    </div>
  </ng-container>
  </form>
</div>